import { combineReducers } from 'redux'
import { createSlice } from '@reduxjs/toolkit'
import { SystemInfoServerData, SystemActiveUsersServerData } from '@lk/api'

import { loadSystemInfo, loadSystemActiveUsers } from './system.actions'

interface SystemInfoState {
  status: 'idle' | 'loading' | 'loaded' | 'failed'
  error: string | null
  data: SystemInfoServerData | null
}

const infoInitialState: SystemInfoState = {
  status: 'idle',
  error: null,
  data: null,
}

export const systemInfoSlice = createSlice({
  name: 'systemInfo',
  initialState: infoInitialState,
  reducers: {},
  extraReducers: {
    [loadSystemInfo.pending.toString()]: (state) => {
      state.status = 'loading'
    },
    [loadSystemInfo.fulfilled.toString()]: (state, action) => {
      state.status = 'loaded'
      state.data = action.payload
    },
    [loadSystemInfo.rejected.toString()]: (state, action) => {
      state.status = 'failed'
      state.error = action.payload
    },
  },
})

interface SystemActiveUsersState {
  status: 'idle' | 'loading' | 'loaded' | 'failed'
  error: string | null
  data: SystemActiveUsersServerData | null
}

const activeUsersInitialState: SystemActiveUsersState = {
  status: 'idle',
  error: null,
  data: null,
}

export const systemActiveUsersSlice = createSlice({
  name: 'systemActiveUsers',
  initialState: activeUsersInitialState,
  reducers: {},
  extraReducers: {
    [loadSystemActiveUsers.pending.toString()]: (state) => {
      state.status = 'loading'
    },
    [loadSystemActiveUsers.fulfilled.toString()]: (state, action) => {
      state.status = 'loaded'
      state.data = action.payload
    },
    [loadSystemActiveUsers.rejected.toString()]: (state, action) => {
      state.status = 'failed'
      state.error = action.payload
    },
  },
})

export const systemReducer = combineReducers({
  info: systemInfoSlice.reducer,
  activeUsers: systemActiveUsersSlice.reducer,
})
